import { render, staticRenderFns } from "./OneNewsPage.vue?vue&type=template&id=8438a2c2&scoped=true&"
import script from "./OneNewsPage.vue?vue&type=script&lang=js&"
export * from "./OneNewsPage.vue?vue&type=script&lang=js&"
import style0 from "./OneNewsPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OneNewsPage.vue?vue&type=style&index=1&id=8438a2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8438a2c2",
  null
  
)

export default component.exports